import { render, staticRenderFns } from "./ApprovalLevel2.vue?vue&type=template&id=ac74f352"
import script from "./ApprovalLevel2.vue?vue&type=script&lang=js"
export * from "./ApprovalLevel2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports